import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/components/portal-dashboard/Dashboard.jsx';


export default class Dashboard {
    constructor() {
        this.container = document.querySelector('#portal-dashboard');

        if (this.container) {
            ReactDOM.render(
                <React.StrictMode>
                    <App featuredContent={this.container.dataset.featuredContent} portalModules={this.container.dataset.modules} contact={this.container.dataset.contact}
                        notifications={this.container.dataset.notifications} role={this.container.dataset.role}
                        filterableGrid={this.container.dataset.filterableGrid} ctaTitle={this.container.dataset.ctaTitle} ctaBody={this.container.dataset.ctaBody}
                        ctaBtnTxt={this.container.dataset.ctaBtnTxt} ctaBtnUrl={this.container.dataset.ctaBtnUrl} ctaImageUrl={this.container.dataset.ctaImageUrl}
                        ctaTheme={this.container.dataset.ctaTheme} ctaSecurityRole={this.container.dataset.ctaRole}
                    />
                </React.StrictMode >,
                document.getElementById('portal-dashboard')
            );
        }


    }
}

window.PortalDashboard = function () {
    ReactDOM.render(<App />, document.getElementById('portal-dashboard'));
    return this;
}